module.exports = __webpack_public_path__ + "img/g1.52531499.jpg";